/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_Li2_MenuInputs */

const tr_onbilgi_s6_li2_menu = /** @type {(inputs: Onbilgi_S6_Li2_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harcamalar > Abonelik`)
};

const en_onbilgi_s6_li2_menu = /** @type {(inputs: Onbilgi_S6_Li2_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spending > Subscription`)
};

const de_onbilgi_s6_li2_menu = /** @type {(inputs: Onbilgi_S6_Li2_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgaben > Abonnement`)
};

const ru_onbilgi_s6_li2_menu = /** @type {(inputs: Onbilgi_S6_Li2_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расходы > Подписка`)
};

/**
* | output |
* | --- |
* | "Spending > Subscription" |
*
* @param {Onbilgi_S6_Li2_MenuInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_li2_menu = /** @type {((inputs?: Onbilgi_S6_Li2_MenuInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_Li2_MenuInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_li2_menu(inputs)
	if (locale === "de") return de_onbilgi_s6_li2_menu(inputs)
	if (locale === "ru") return ru_onbilgi_s6_li2_menu(inputs)
	return tr_onbilgi_s6_li2_menu(inputs)
});